import React from 'react';
import styled from 'styled-components';

const TitleContainer = styled.div`
  .title {
    font-size: 1em;
    font-family: ${(props) => props.theme.fonts.oswald};
    color: ${(props) => props.theme.colors['terra-cotta']};
    text-transform: uppercase;
    font-weight: 400 !important;
  }

  @media (max-width: 1400px) {
    font-size: 16px;
  }
`;

const TitleComponent = ({ children }) => (
  <TitleContainer>
    <div className="title">{children}</div>
  </TitleContainer>
);

export default TitleComponent;
